export default __webpack_public_path__ + "static/Gibson-Light-c53122219446d5edcdc8c903e8c1d4b0.woff";